import type { RoleType } from '@/features/role/domain/enums/RoleType'
import type { CreateUpdateCancelOrderReasonTranslationEntity } from './CreateUpdateCancelOrderReasonTranslationEntity'

export class CreateUpdateCancelOrderReasonEntity {
  role?: RoleType
  translations?: Array<CreateUpdateCancelOrderReasonTranslationEntity>
}
